import React from 'react'
import { renderCollectionItem } from '../utils/collectionUtils'

interface ReferenceValueDisplayProps {
  itemId: string | number
  showPrefix?: boolean
  collectionItems: Record<string, any>
  /** Truncate the displayed name to this many chars with an ellipsis. Used by
   *  chip-strip surfaces where `whitespace-nowrap` makes long names overflow. */
  maxLen?: number
}

const ReferenceValueDisplay: React.FC<ReferenceValueDisplayProps> = ({
  itemId,
  showPrefix = true,
  collectionItems,
  maxLen,
}) => {

  const item = collectionItems[String(itemId)]

  if (!item) {
    return <span>{showPrefix ? ': ' : ''}#{itemId}</span>
  }

  const collection = item.collection
  let displayName: string

  if (collection) {
    // Use the display template if available
    displayName = renderCollectionItem(item, collection)
  } else {
    // Simple fallback using item data
    displayName = item.data?.['first name'] || item.data?.name || `#${itemId}`
  }

  if (maxLen && displayName.length > maxLen) {
    displayName = `${displayName.slice(0, maxLen - 1)}…`
  }

  return <span>{showPrefix ? ': ' : ''}{displayName}</span>
}

export default ReferenceValueDisplay